<template>
  <div class="content">

    <c가상입금 ref="vrIncome" @save="v=>{doSearch(); doInSearch();}"/>


  <!-- draggable=".window-header" -->
  <modal
    name="buy_ok_modal"
    adaptive
    @opened="callDialogBuyConfirm_opened"
    width="600"
    height="auto" scrollable
    reset
  >

    <i-bar title="증표 신청 완료"  class="window-header">
      <i-bar-btn v-if="buy_ok_item.paystat == 'OK'" @click="goPrint(buy_ok_item)">인쇄하기</i-bar-btn>
      <i-bar-btn @click="$modal.hide('buy_ok_modal')">닫기</i-bar-btn>
    </i-bar>

    <c증표구입완료 ref="buy_ok" />

  </modal>
      <s-location buy title="증표 구입 내역"/>

      <h4 class="sub_title02 ">증표 구입 내역</h4>
        <div class="btn_group mt0">
          <div class="right">
            <button @click="initData" class="btn icon reload">초기화</button>
            <button @click="doSearch" class="btn icon search_black">검색</button>
            <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
          </div>
        </div>
        <table class="tbl01 sch_tbl">
          <tr>
            <th>구입 신청일</th>
            <td>
              <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_incmgdtfr" :placeholder="search.iv_incmgdtfr"/>
            ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_incmgdtto" :placeholder="search.iv_incmgdtto"/>
            <br class="mobile"/>
              <s-date-range :fr.sync="search.iv_incmgdtfr" :to.sync="search.iv_incmgdtto" />
            </td>
          </tr>
          <tr>
            <th>구입 신청 명의자</th>
          <td><input type="text" class="sch_input" v-tooltip="'구입 신청 명의자'" v-model="search.iv_membnm_owner" placeholder="구입 신청 명의자" @keyup.enter="doSearch()"/>
          </td>
          </tr>
<!-- 검색 조건 작업 예정
          <tr>
            <th>검색어</th>
            <td>
              <select v-model="search.iv_ktype">
                <option value="ALL"      >전체</option>
                <option value="MEMBNM"   >증표명의</option>
                <option value="CLIENT"   >위임인</option>
                <option value="OTHERSIDE">상대방</option>
                <option value="REMK"     >비고</option>
              </select>
              <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" />
            </td>
          </tr>
 -->
          <tr>
            <th>입금 상태</th>
            <td>
              <input type="checkbox" v-model="chkAll" id="s_0" @change="checkAll"/> <label for="s_0">전체</label>
              <span v-for="(item, i) in code.PAYSTAT" :key="i">
                <input type="checkbox"
                      :value="item.value"
                      :id="item.value"
                      v-model="search.iv_paystat"
                />

                <label :for="item.value">{{ item.text }}</label>
                <br class="mobile" v-if=" i == 1 ||  i == 4  " />
              </span>
            </td>
          </tr>
      </table>

      <s-excel
        ref="excel"
        excel-api="/proc_excel/N_SEL_SELLINFO_LIST"
        excel-filename = "증표_구입_내역"
        :isDebug="false"
        :excel-top ="`

          조회기간 : ${ search.iv_incmgdtfr } ~ ${ search.iv_incmgdtto }

        `"
        excel-headers = "
            text              | value          | format              | align | calc
            구입신청일        | incmgdt        | YYYY.MM.DD HH:MM:SS
            구입 신청 명의자  | membnm         |
            본안              | tnocnt1        |
            민사소액          | tnocnt6        |
            민사고액          | tnocnt7        |
            신청              | tnocnt2        |
            등기              | tnocnt3        |
            금액              | pay_amt        | comma               | right | sum
            입금여부          | paystatnm      |
            입금일            | sellpayokdt    | YYYY.MM.DD HH:MM:SS
        "

        :excel-param = "()=>({
          ...search,
          iv_pgsize      : '-1',
          iv_page        : '1',
          iv_paystat     : this.search.iv_paystat.join('#'),
          iv_sellclsf    : 'BB0100',
          iv_sellplac    : 'B21100',
          iv_agntpersnm  : '',
          iv_agntpersprn : '',
          iv_selldtfr    : '',
          iv_selldtto    : '',
          iv_vraccno     : '',
      })"/>

      <s-loading v-if="list.loading"/>
      <!-- 테이블 -->
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt "> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 vialist">
          <thead>
            <tr>
              <th rowspan="2" class="no" style="width: 70px;">순번</th>
              <th rowspan="2" class="day" style="width: 70px;">구입<br/>신청일<br/>(입금일)</th>
              <th rowspan="2" style="border-right: 1px solid #999999;">구입 신청 <br/>명의자</th>
              <th colspan="5" width="gubun"> 구분</th>
              <th rowspan="2">금액</th>
              <th rowspan="2" width="80px">입금은행<br/>입금계좌번호</th>
              <th rowspan="2" width="80px">입금여부<br/>(마감일시)</th>
              <th rowspan="2" width="40px">신청<br/>확인서</th>
              <th rowspan="2" width="40px">영수증</th>
              <th rowspan="2" width="80px">비고</th>
            </tr>
            <tr class="gubun_d">
                <th>본안</th>
                <th style="line-height: 17px;">민사<br/>소액</th>
                <th style="line-height: 17px;">민사<br/>고액</th>
                <th>신청</th>
                <th>등기</th>
            </tr>
          </thead>
            <tr v-for="(item,i) in list.items" :key=i>
              <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
              <td>
                {{ item.incmgdt | moment('YYYY.MM.DD.') }}
                <div v-if="!T.isEmpty(item.sellpayokdt)">({{ item.sellpayokdt | moment('YYYY.MM.DD.') }})</div>
              </td>
              <td style="border-right: 1px solid #999999;"><!-- 구입신청 명의자 -->
                {{ item.membnm  }}
                <div v-if="item.officenm">
                  {{ T.wrap유한(item.officenm) }}
                </div>
              </td>
              <td>{{ item.tnocnt1 }}</td>
              <td>{{ item.tnocnt6 }}</td>
              <td>{{ item.tnocnt7 }}</td>
              <td>{{ item.tnocnt2 }}</td>
              <td>{{ item.tnocnt3 }}</td>
              <td class="ar_amt">{{ item.pay_amt | comma }}</td>
              <td class="ar_amt">신한은행<br/>{{ item.vraccno }}</td>
              <td>
                <p class="red01">{{ item.paystatnm }}</p>
                <!-- [입금여부] : 입금완료, 취소 시 [마감일시]가 안나오도록  -->
                <div v-if="item.paystat != 'OK' && item.paystat != 'CANCEL'" style="font-size: 11px;">
                  ({{ item.paylimitdt | moment("YYYY.MM.DD HH:mm:ss") }})
                </div>
                <!-- <button v-if="item.paystat == 'READY'" class="btn xs gray01 outline" @click="vrIncome(item)">테스트용 가상입금</button> -->
                <!-- 입금대기일 경우에만 취소버튼 -->
                <button
                  v-if="item.paystat == 'READY'"
                  class="btn xs gray01 outline"
                  @click="doChangeCancel(item)">취소</button>
              </td>
              <td><button class="btn xs gray01 outline" @click="callDialogBuyConfirm(item)">확인</button></td>
              <td>
                <!-- 인쇄버튼 : 입금완료일때만 보이게 함-->
                <button
                  v-if="item.paystat == 'OK'"
                  @click="goPrint(item)"
                  class="btn xs gray01 outline">인쇄</button>
               </td>
               <td>
                 {{ item.remk }}
               </td>
            </tr>
        </table>
      </div><!--//scroll_wrap -->
      <!-- //테이블 -->
      <div class="paging">
        <p class="num">
            <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
        </p>
      </div>


      <div v-if="inlist.totalCount" >
        <h4 class="sub_title02">입금 오류 내역</h4>
        <s-loading v-if="inlist.loading" />

        <!--  주의사항  -->
        <div class="comment_gray expcomment">
          <!-- <li>가상계좌로 입금은 되었으나 기간만료 및 금액불일치 또는 동일금액 다수건이라서 자동 입금완료되지 못한 미처리 입금건이
                <b class="ft16 red01">총 {{ inlist.totalCount }} 건 ({{ chk_amt_tot() | comma }}원)</b>이 있습니다.</li> -->
          <!-- <li>[수동처리] 또는 여러 입금건을 선택 후 [모아서 수동처리]를 클릭하여 입금대기 구입내역을 선택하시면 입금을 직접 완료하실 수 있습니다.</li> -->
          <li class="mt10"><b>입금오류란?</b>
              <p>-구입신청한 금액과 실제 가상계좌로 입금한 금액이 일치하지 않는 경우</p>
              <p>-가상계좌로 입금한 금액은 1건인데, 2건 이상의 동일한 금액의 신청 내역이 있는 경우</p>
              <p>- 입금기한이 만료된 후 가상계좌로 입금한 경우</p>
          </li>
            <span class="btn blue01 outline xs mt5" @click="$modal.show('comment')" >입금오류 처리방법</span>
          <modal
          name="comment"
          draggable=".window-header"
          width="700"
          height="auto"
          :scrollable="false"
          :adaptive="true"
          reset
          >
            <i-bar title="예시" class="window-header" style="padding-right: 10px;">
              <i-bar-btn @click="$modal.hide('comment')">닫기</i-bar-btn>
            </i-bar>
              <div class="cont" style="padding: 10px; font-size: 14px;">
                <ol>
                  <li><b>초과 입금한 경우</b>
                    <p>수동처리 > 선택 > 은행명, 환불계좌번호, 예금주, 통장사본 첨부 > 확인</p>
                  </li>
                  <li><b>부족 입금한 경우</b>
                    <p>가. 전액환불<br/>
                      <p>수동처리 > 전액환불 > 은행명, 환불계좌번호, 예금주, 통장사본 첨부 > 전액환불신청
                    </p>
                    <p>나. 부족분 입금 후 정상처리<br/>
                    동일한 가상계좌번호에 부족금 입금 > 입금오류 목록에서 해당 금액 체크박스 선택 > 모아서 수동처리 > 선택 >확인
                    </p>
                  </li>
                  <li><B>기간 만료후 입금한 경우</B><br/>
                      수동처리 > 선택 > 확인<br/>
                      ( 단, 기간만료 신청건이라도 1주일 지난 신청은 선택할 수 없습니다. )</li>
                  <li><b>가상계좌로 입금한 금액은 1건인데, 2건 이상의 동일한 금액의 신청 내역이 있는 경우</b><br/>
                      수동처리 > 선택 > 확인
                  </li>
                  <p> &nbsp; &nbsp; &nbsp; (회원 소속정보 변경 내역은 다음날 반영됩니다)</p>
                </ol>
            </div>
          </modal>

        </div>
      <div class="scroll_wrap">
          <p class="scroll_txt "> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

          <table class="tbl01 mb5">
            <thead>
              <tr>
                <th width="60px">
                  <!-- 전체 체크/해제 -->
                  <input type="checkbox"
                    v-if="inlist.totalCount > 1"
                    @change="e=>inlist.items.forEach(v=>v.chk = e.target.checked)" />
                  순번
                </th>
                <th width="100">입금일</th>
                <th width="200">입금계좌</th>
                <th>입금자</th>
                <th width="80">금액</th>
                <th width="73">수동처리</th>
              </tr>
            </thead>
            <tr v-for="(item,i) in inlist.items.slice(inlist.listSize * (inlist.pageNo - 1), inlist.listSize * inlist.pageNo)" :key="'ink_'+i">
              <td>
                <!-- 개별 체크/해제 -->
                <input type="checkbox" v-if="inlist.totalCount > 1" v-model="item.chk" />
                {{ inlist.totalCount - ((inlist.pageNo -1) * inlist.listSize) - i }}
              </td>
              <td>{{ item.vrtradedt | moment('YYYY.MM.DD.') }}</td>
              <td>{{ item.vraccno  }}</td>
              <td>{{ item.custname }}</td>
              <td>{{ item.amt | comma  }}원</td>
              <!-- <td>{{ item.tradestatnm  }}</td> -->
              <td>
                <button class="btn xs org01 outline" @click="vr_trace_work_popup('one', item, null)">수동처리</button>
              </td>
            </tr>
          </table>
	    </div><!-- //scroll_wrap -->


        <div v-if="inlist.totalCount > 0" class="clearfix">
          <button class="btn xs org01 btn_noauto left  " @click="vr_trace_work_popup('multi', null, inlist.items)">
            <template v-if="chk_amt() > 0">
              {{ chk_cnt() }}건 {{ chk_amt() | comma }}원 모아서 수동처리
            </template>
            <template v-else>
              선택건 모아서 수동처리
            </template>
          </button>
          <!-- <div v-if="chk_cnt() > 1">
            ※ 2건이상 선택하여 수동처리할 경우에는 전액환불을 할 수 없습니다.<br/>
            &nbsp; &nbsp;입금완료 처리 없이 입금건 그대로 전액환불이 필요한 경우 위의 한건만 선택하거나 위의 [수동처리]를 사용하세요.
          </div> -->
        </div>

        <div v-if="inlist.totalCount > inlist.listSize" class="paging">
          <p class="num" style="margin-top: 0">
            <s-page :pageNo.sync="inlist.pageNo" :totalCount="inlist.totalCount" :listSize="inlist.listSize"/> </p>
        </div>

      </div> <!-- //scroll_wrap -->


      <div v-show="rflist.totalCount > 0" class="clearfix">
        <h4 class="sub_title02 ">과오납 환불 신청 내역
          <button class="btn xs blue01 outline right ml10" @click="$router.push('/apply/stat_list')">자세히보기</button>
        </h4>
        <s-table3 onepage hideFooter
          ref        = "rfmain"
          headerThClass = "test01"
          :list.sync  = "rflist"
          list-api   = "/proc/N_REFUND_SEL_LIST"
          :list-param = "list=>({
            iv_refunddtfr  : $moment().add(-90, 'day').format('YYYYMMDD'),
            iv_refunddtto  : '',
            iv_refundclsf  : 'MANUAL',
            iv_rfway       : '',
            iv_rfstat      : '',
            iv_pgsize      : 1000,
            iv_page        : 1,
          })"

          keys    = "refunddt,refundseq"
          headers = "
            text            | value        | width | align  | sortable
            (default)       |              |       | center | false
            순번            | _no          | 40
            신청일          | refunddt     | 70
            환불구분        | refundclsfnm | 70
            은행            | rfbankcodenm | 100
            계좌번호        | rfaccno
            예금주          | rfaccname    | 50
            금액            | rf_amt       | 60
            환불상태        | rfstatnm     | 60
            비고            | approvemsg
            환불접수일자    | rfokdt       | 80
            재신청          | remanual     | 40
          ">
          <template v-slot:item._no="{value,item,_no}">{{ _no }}</template>
          <template v-slot:item.refunddt ="{value}">{{ value | moment("YYYY.MM.DD") }}</template>
          <template v-slot:item.rf_amt="{value}">{{ value | comma }}</template>
          <template v-slot:item.rfokdt ="{value}">{{ value | moment("YYYY.MM.DD") }}</template>
          <template v-slot:item.remanual="{value, item}">
            <i-btn v-if="item.rfstatnm == '반려'" @click="reManual(item)" class="btn xs org01 outline">재신청</i-btn>
          </template>
        </s-table3>
        <div class="comment_star red red01">접수일로부터 일주일 이내에 요청하신 계좌로 환불처리 됩니다.</div>
      </div>

    </div> <!-- content : width=950px; -->
</template>

<script>
let ui

export default {
  components: {
    'c증표구입완료'   : require('@/components/c증표구입완료.vue').default,
    'c가상입금'       : require('@/components/c가상입금.vue').default,
  },
  data() {
    return {
      search : {},
      search_init : {
        iv_paystat : []
      , iv_incmgdtfr : this.$moment().subtract(1, 'months').format("YYYY-MM-DD")
      , iv_incmgdtto : this.$moment().format("YYYY-MM-DD")
      , iv_membnm_owner : ''
      },
      sitem : {},
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      inlist: { // 입금내역
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      rflist: { // 입금내역
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10000,
        pageNo : 1,
      },

      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      buy_ok_item : {},
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("PAYSTAT", code => {
      this.code = code
      // 입금상태 검색조건 : 기존자료 제외
      this.code.PAYSTAT = this.code.PAYSTAT.filter(e => e.value != 'MI')
      this.doSearch()
      this.doInSearch()
      this.$refs.rfmain.load()
    });
  },
  methods: {
    chk_cnt()     { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.chk ? 1 : 0,0) }, // 총 미처리 입금 건수
    chk_amt()     { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.chk ? p.amt : 0,0) }, // 선택한 미처리 입금 금액 합계
    chk_amt_tot() { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.amt,0) },  // 총 미처리 입금 금액 합계
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.doSearch()
      this.doInSearch()
      this.$refs.rfmain.load()
    },
    goPrint (item) {
      let {sellregdt, sellseq, sellpayokdt} = item
      sellpayokdt = this.$moment(sellpayokdt).format("YYYY.MM.DD")
      this.$router.push({ path: 'buy_receipt_list', query: { sellregdt, sellseq, sellpayokdt }})
    },
    callDialogBuyConfirm(item) {
      this.buy_ok_item = item
      this.$modal.show('buy_ok_modal'); // opened() call
    },
    callDialogBuyConfirm_opened() {
      this.$refs.buy_ok.load(this.buy_ok_item)
    },
    disabledDate (date) {
      return date.getTime() < Date.now()
    },
    checkAll() {
      let selected = []

      // 체크한 경우
      if (this.chkAll) {
        this.code.PAYSTAT.forEach(e => {
          selected.push(e.value)
        })
      }

      this.search.iv_paystat = selected
    },
    doSearch() {
      //this.search.iv_incmgdtfr = reaplace(this.)
      this.$ui.httpGetList(this.list
        , '/proc/N_SEL_SELLINFO_LIST'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
          , iv_paystat     : this.search.iv_paystat.join("#")
          , iv_sellclsf    : 'BB0100' // 판매구분 : 판매
          , iv_sellplac    : '' // 경유처   : 온라인
          , iv_agntpersnm  : ''
          , iv_agntpersprn : ''
          , iv_selldtfr    : ''
          , iv_selldtto    : ''
          , iv_vraccno     : ''
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    doInSearch() { // 입금 리스트
      //this.search.iv_incmgdtfr = reaplace(this.)
      this.$ui.httpGetList(this.inlist, '/proc/N_VRTRADE_LIST_V02'
        , {
          iv_pgsize        : -1,
          iv_page          : this.inlist.pageNo,
          iv_tradestat     : "NOMATCH",
        },
        ret => {
          this.inlist.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.inlist.items      = T.arraySetAll(_.get(ret, "data.rs2", []), {chk: false})
        })
    },
    vrIncome(sitem){
      this.$refs.vrIncome.open(sitem)
    },
    doChangeCancel(item) {
      ui.confirm('취소하시겠습니까 ?', "취소확인")
        .then(r => r && this.itemUpdate(item))
    },
    itemUpdate(item) {
      ui.httpPost("/proc_iv/N_SELLINFO_PAYSTAT_UPD",
      {
        ...item
        , paystat : 'CANCEL'
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때
           this.doSearch()
        }
      })
    },

    /* 입금내역 수동처리 */
    vr_trace_work_popup(mode, item, items) {
      let itemsp = []
      if (mode == 'multi') {
        itemsp = items != null ? items.filter(v=>v.chk) : []
        if (itemsp.length < 1)
          return ui.alert("수등으로 처리할 입금건을 선택해 주세요")
      } else {
        itemsp = [item]
      }
      if (itemsp.some(v=>v.vraccno != itemsp[0].vraccno))
        return ui.alert("여러건을 선택할 경우 입금계좌가 전부 동일해야 합니다.")

      this.$modal.show(require('./c입금내역_수동처리.vue').default, {
        // item : _.pick(item, ['REPTYY', 'REPSEQ']),
        items : itemsp,
        parentReload : v=>{this.doSearch(); this.doInSearch();this.$refs.rfmain.load()}, // 팝업에서 부모 새로고침 호출
      }, {
        // 모달 속성
        name: "c입금내역_수동처리",
        height: 'auto',
        scrollable: false, // height: auto 하고 scrollable:true 는 한세트
        width: 960,
        // draggable: true,
        draggable: ".window-header",
        resizable: true,
        adaptive: true,
        pivotY: 0.3,
        reset: true,
      }, {
        // 이벤트
        // 'before-close': (e,v) => { console.log('모달을 닫는다1. event =', e); console.log('모달을 닫는다2. event =', v);  },
        // 'closed': (e,v) => { console.log('모달3 CLOSED =', e); console.log('모달4 CLOSED =', v); },
      })
    },

    reManual(item){
      let itemsp = []
      itemsp = [item]
      this.$modal.show(require('./c입금내역_re수동처리.vue').default, {
        items : itemsp,
        parentReload : v=>{this.doSearch(); this.doInSearch();this.$refs.rfmain.load()}, // 팝업에서 부모 새로고침 호출
      }, {
        // 모달 속성
        name: "c입금내역_re수동처리",
        height: 'auto',
        scrollable: false, // height: auto 하고 scrollable:true 는 한세트
        width: 960,
        // draggable: true,
        draggable: ".window-header",
        resizable: true,
        adaptive: true,
        pivotY: 0.3,
        reset: true,
      }, {
      })
    }
  },
}
</script>
<style scoped>
  .tbl01 th { max-width:8%;}
  .tbl01 th.gubun { width:300px;}
  .tbl01 tr.gubun_d th { width:40px; padding: 0; margin: 0}

  #id_msg:hover .toggleInfo {  margin-top:50px; margin-left:-30px; display: inline-block;  width:750px;}
  .toggleInfo .tit_info {  color:#fff; display: inline-block; padding: 10px 15px 10px 40px; ;width:100%; box-sizing: border-box; font-size: 15px;;background:#333 url('/images/common/icon_info_org.png')  15px 50% no-repeat;  ;}

  @media screen and (max-width:640px){
    #id_msg:hover .toggleInfo {  margin-top:-100px; margin-left:-124px; display: inline-block; width:98%;}
    .paging { clear:both; width:100%}
    .tbl01.sch_tbl th { width:95px;}
  }


</style>